import {
  getSeasonCompaniesAction,
  getSeasonCountriesAction,
  getSeasonsAction,
  getSeasonsProductionAction,
} from './actions';
import { defaultListParams, listReducer } from '../../utils/crudUtils';

export const key = 'SeasonsPage';

export const initialState = {
  seasonCompanies: defaultListParams,
  seasons: defaultListParams,
  countries: defaultListParams,
  seasonsProduction: defaultListParams,
  error: null,
};

const seasonsPageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getSeasonsAction.TRIGGER:
    case getSeasonsAction.SUCCESS:
    case getSeasonsAction.FAILURE:
      return listReducer(state, type, payload, 'seasons');

    case getSeasonCompaniesAction.TRIGGER:
    case getSeasonCompaniesAction.SUCCESS:
    case getSeasonCompaniesAction.FAILURE:
      return listReducer(state, type, payload, 'seasonCompanies');

    case getSeasonCountriesAction.TRIGGER:
    case getSeasonCountriesAction.SUCCESS:
    case getSeasonCountriesAction.FAILURE:
      return listReducer(state, type, payload, 'countries');

    case getSeasonsProductionAction.TRIGGER:
    case getSeasonsProductionAction.SUCCESS:
    case getSeasonsProductionAction.FAILURE:
      return listReducer(state, type, payload, 'seasonsProduction');

    default:
      return state;
  }
};

export default seasonsPageReducer;
